/* eslint-disable react/prefer-stateless-function */
import React, { PureComponent } from "react";

class Landing extends PureComponent {
  render() {
    return <p>Success</p>;
  }
}

export default Landing;
